module.exports = __webpack_public_path__ + "static_pc/img/3.c66a7c6c.png";